module.exports = require('./lib/eql');



/*****************
 ** WEBPACK FOOTER
 ** ./~/chai/~/deep-eql/index.js
 ** module id = 25
 ** module chunks = 1
 **/